import React, { Component } from 'react'
import { connect } from 'react-redux'

import placeholderIcon from '../../../../assets/images/placeholder-icon.svg'
import _ from 'lodash'

class BkFlowRoomDetailsIcons extends Component {
	constructor(props) {
		super(props)
		this.state = {
		}
	}

	renderDetailIcons() {
		const {
			roomGroup,
			roomData,
			displayAllIcons,
			availabilityData
		} = this.props

		let roomTypeIcons = []

		// construct featured amenities icons array
		if (
			roomData &&
			_.get(roomData, 'viewExtensions.roomAmenityIcons') &&
			!_.isEmpty(roomData.viewExtensions.roomAmenityIcons)
		) {
			const roomAmenities = roomData.viewExtensions.roomAmenityIcons

			for (const amenityKey in roomAmenities) {
				const currentAmenity = roomAmenities[amenityKey]

				if (displayAllIcons) {
					roomTypeIcons.push(currentAmenity)
				} else if (!currentAmenity.isFeatured) {
					roomTypeIcons.push(currentAmenity)
				}
			}
			const hotelCode = availabilityData[0][0].basicPropertyInfo.hotelCode
			const roomSize = _.get(roomData, 'viewExtensions.roomSize')
			if (roomSize) {
				const sqft = _.get(roomSize, 'value')
				const sqm = Math.round(sqft * 0.092903)
				const roomSizePostfix = _.get(roomSize, 'approximate')
					? ` ${_.get(roomSize, 'approximate')}`
					: ''
				if (hotelCode.toString() === 'B7G6') { // Want to add to the top of the amenity list and show sq.ft first for Mondriane Gold Coast
					roomTypeIcons.unshift({
						'@id': _.get(roomSize, '@id'),
						'@type': 'IconViewExtension',
						caption: '',
						description: '',
						filterable: false,
						isFeatured: false,
						name: `${sqm} sqm/${sqft} sq. ft${roomSizePostfix}`,
						path: _.get(roomSize, 'image.path')
					})
				} else {
					roomTypeIcons.push({
						'@id': _.get(roomSize, '@id'),
						'@type': 'IconViewExtension',
						caption: '',
						description: '',
						filterable: false,
						isFeatured: false,
						name: `${sqft} sq. ft/${sqm} sqm ${roomSizePostfix}`,
						path: _.get(roomSize, 'image.path')
					})
				}
			}
		}

		let renderIconData = []

		for (let iconKey in roomTypeIcons) {
			if (roomTypeIcons[iconKey].name && roomTypeIcons[iconKey].path) {
				renderIconData.push(
					<div
						key={ roomTypeIcons[iconKey].name.replace(/\s+/g, '-').toLowerCase() + '-' + roomData.roomTypeCode + '-' + roomGroup }
						className="bk-flow-room__details-icon"
					>
						{ roomTypeIcons[iconKey].path ?
							<div className="bk-flow-room__details-icon-src">
								<img
									className={'u-icon u-icon-' + roomTypeIcons[iconKey].name.replace(/\s+/g, '-').toLowerCase() }
									src={ roomTypeIcons[iconKey].path }
									alt={ roomTypeIcons[iconKey].name }
								/>
							</div>
							:
							<div className="bk-flow-room__details-icon-src">
								<img
									className="u-icon u-icon-placeholder"
									src={ placeholderIcon }
									alt={ roomTypeIcons[iconKey].name }
								/>
							</div>
						}

						{ roomTypeIcons[iconKey].name && <p className='u-font-small'>{ roomTypeIcons[iconKey].name }</p> }
					</div>
				)
			}
		}

		return renderIconData
	}

	render() {
		let baseClassNames = 'bk-flow-room__details-icons rows'

		if (process.env.REACT_APP_COMPONENT_FEATURED_ICONS_COMPONENT === 'columns') {
			baseClassNames = 'bk-flow-room__details-icons columns'
		}

		return (
			<div className={baseClassNames}>
				{ this.renderDetailIcons() }
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration,
		availabilityData: state.availabilityData.availability,
	}
}

export default connect(mapStateToProps, null)(BkFlowRoomDetailsIcons)


// WEBPACK FOOTER //
// ./src/components/room/elements/icons/BkFlowRoomDetailsIcons.js